<template>
  <div id="app" data-server-rendered="true">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      fullscreenLoading: false
    }
  },
  metaInfo () {
    return {
      title: 'Pagos con Criptomonedas como Bitcoin, Ethereum, EOS y Stellar en tu tienda.',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          'name': 'title',
          'content': 'Pagos con Criptomonedas como Bitcoin, Ethereum, EOS y Stellar en tu tienda.',
          'vmid': 'name'
        },
        {
          'itemprop': 'description',
          'content': 'Recibe pagos gratis, convierte automáticamente a divisa local sin problemas',
          'vmid': 'description'
        },
        {
          'itemprop': 'image',
          'content': 'https://www.cryptocompra.com/static/favicon/cryptocompra.png',
          'vmid': 'image'
        },
        {
          'property': 'og:title',
          'content': 'Pagos con Criptomonedas como Bitcoin, Ethereum, EOS y Stellar en tu tienda.',
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'content': 'Recibe pagos gratis, convierte automáticamente a divisa local sin problemas',
          'vmid': 'og:description'
        },
        {
          'property': 'og:image',
          'content': 'https://www.cryptocompra.com/static/favicon/cryptocompra.png',
          'vmid': 'og:image'
        },
        {
          'property': 'og:type',
          'content': 'website',
          'vmid': 'og:type'
        },
        {
          'property': 'og:url',
          'content': 'https://www.cryptocompra.com/',
          'vmid': 'og:url'
        },
        {
          'property': 'og:site_name',
          'content': 'CryptoCompra by CryptoMarket',
          'vmid': 'og:site_name'
        },
        {
          'name': 'twitter:title',
          'content': 'Pagos con Criptomonedas como Bitcoin, Ethereum, EOS y Stellar en tu tienda.',
          'vmid': 'twitter:title'
        },
        {
          'name': 'twitter:description',
          'content': 'Recibe pagos gratis, convierte automáticamente a divisa local sin problemas',
          'vmid': 'twitter:description'
        },
        {
          'name': 'twitter:card',
          'content': 'summary',
          'vmid': 'twitter:card'
        },
        {
          'name': 'twitter:image',
          'content': 'https://www.cryptocompra.com/static/favicon/cryptocompra.png',
          'vmid': 'twitter:image'
        },
        {
          'name': 'twitter:image:alt',
          'content': 'Recibe pagos gratis, convierte automáticamente a divisa local sin problemas',
          'vmid': 'twitter:image:alt'
        },
        {
          'name': 'twitter:site',
          'content': '@CryptoMKT',
          'vmid': 'twitter:image'
        },
        { name: 'description', content: 'Recibe pagos gratis, convierte automáticamente a divisa local sin problemas' }
      ]
    }
  },
  created(){
    if(this.$store.state.app){
      // geocoder default origin
      // this.$geocoder.setDefaultCountryCode(this.$store.getters['lang/getShortLang'].toUpperCase());
      // this.$geocoder.setDefaultCountryCode('CL');
      this.$geocoder.setDefaultLanguage('es');
    }

  },
  mounted() {
    this.fullscreenLoading = false;
  }
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* padding: 1vh 1vw; */
}
body{
  margin: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue